import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientService } from '../../services/patient.service';
import { ErrorPanelService } from '../../services/error-panel.service';

@Component({
  selector: 'app-patient-card',
  standalone: false,
  templateUrl: './patient-card.component.html',
  styleUrl: './patient-card.component.scss',
})
export class PatientCardComponent {
  showConfirmationPanel = false;
  @Input() id?: string = '';
  @Input() patientName: string = '';
  @Input() patientSurname: string = '';
  @Input() today: boolean = false;
  @Input() interviewDate: string = '';
  @Input() interviewTime?: string = '';
  @Input() isActive?: boolean = true;
  @Input() mobile?: string = '';
  @Input() email?: string = '';
  @Input() size: string = 'small';
  @Output() patientDeleted = new EventEmitter<void>();
  @Output() patientClicked = new EventEmitter<void>();

  constructor(
    private patientService: PatientService,
    private errorPanelService: ErrorPanelService
  ) {}

  navigateToPatientPage() {
    this.patientClicked.emit();
  }

  toggleConfirmationPanel() {
    this.showConfirmationPanel = !this.showConfirmationPanel;
  }

  deletePatient() {
    this.patientService.deletePatient(this.id || '').subscribe({
      next: () => {
        this.patientDeleted.emit();
      },
      error: () => {
        this.errorPanelService.showErrorSnackBar(
          'Errore durante la cancellazione del paziente'
        );
      },
    });
  }
}
